export default {
  language: "波兰语",
  女装: "Odzież damska",
  男装: "Męskie",
  手机和小工具: "Telefon komórkowy i małe narzędzia",
  居家生活: "Życie domowe",
  电脑及周边设备: "Sprzęt komputerowy i peryferyjny",
  美容及个人护理: "Piękno i opieka osobista",
  家用电器: "Urządzenie",
  健康与保健: "Zdrowie i opieka zdrowotna",
  食品和饮料: "Jedzenie i picie",
  玩具_儿童和婴儿: "Zabawki, dzieci i dzieci",
  童装时尚: "Moda odzieży dla dzieci",
  视频游戏: "gry wideo",
  运动与户外: "Ćwiczenia i na zewnątrz",
  爱好与书籍: "Hobby i książki",
  相机和无人机: "Aparat i drony",
  宠物食品及用品: "Karma dla zwierząt domowych i zapasy",
  女士包袋: "Torba dla kobiet",
  男士包袋: "Torba męska",
  珠宝及配饰: "Biżuteria i akcesoria",
  手表: "oglądać",
  女鞋: "Buty damskie",
  男装鞋: "Buty męskie",
  汽车: "samochód",
  我附近的ShopeePay: "Mój pobliski shopeepay",
  餐饮_旅行和服务: "Catering, podróż i obsługa",
  旅行及行李: "Podróż i bagaż",
  各种各样的: "Różny",
  我是来买什么的: "Jestem tutaj, żeby kupić",
  对不起_找不到_相关的商品:
    "Przepraszam, nie możesz znaleźć powiązanych produktów [{0}]",
  类别: "kategoria",
  产品: "produkt",
  店铺: "Sklep",
  首页: "strona tytułowa",
  限时秒杀: "Ograniczony czas czasowy",
  博客: "blog",
  所有品牌: "Wszystkie marki",
  所有类别: "Wszystkie kategorie",
  我的购物车: "Mój koszyk",
  发货信息: "Informacje o dostawie",
  交货信息: "Informacje o dostawie",
  付款: "Zapłata",
  确认: "potwierdzać",
  您的购物车是空的: "Twój koszyk jest pusty",
  价格: "cena",
  税: "Podatek",
  数量: "ilość",
  总计: "całkowity",
  移除: "Usunąć",
  返回商店: "Wróć do sklepu",
  继续发货: "Kontynuuj dostawę",
  筛选: "filtr",
  价格范围: "Cena",
  排序方式: "sortować",
  最新: "aktualne",
  最旧: "Stary",
  价格从低到高: "Cena z niskiego do wysokiego",
  价格从高到低: "Cena z wysokiego do niskiego",
  选择交货类型: "Wybierz typ dostawy",
  送货上门: "Dostawa",
  继续付款: "Nadal płacić",
  任何其他信息: "Wszelkie inne informacje",
  或者: "Lub",
  您的钱包余额: "Twoja równowaga portfela",
  余额不足: "Niewystarczająca równowaga",
  支付: "Płacić",
  我同意: "Zgadzam się",
  条款和条件: "Warunki",
  退货政策: "Polityka zwrotu",
  隐私政策: "Prywatność",
  概括: "Zsumować",
  项目: "projekt",
  全部的: "Wszystkie -Round",
  小计: "Naszkicować",
  总运费: "Całkowity fracht",
  有优惠码吗_在这里输入: "Czy istnieje kod rabatowy? Wprowadź tutaj",
  申请: "Stosować",
  编辑: "redagować",
  删除: "usuwać",
  添加新地址: "Dodaj nowy adres",
  继续交货信息: "Kontynuuj informacje o dostawie",
  选择一个地址: "Wybierz adres",
  购买历史: "Kup historię",
  下载: "pobierać",
  已发送退款请求: "Żądanie zwrotu Wysyła wniosek o zwrot pieniędzy",
  对比: "kontrast",
  对话: "dialog",
  我的钱包: "Mój portfel",
  工单: "Zlecenie pracy",
  管理个人资料: "Zarządzaj danymi osobowymi",
  登出: "Wyloguj się",
  重置对比列表: "Zresetuj listę porównawczych",
  您的对比列表为空: "Twoja lista porównawczy jest pusta",
  在您的购物车中: "W swoim koszyku",
  在您的愿望清单中: "Na twojej liście życzeń",
  在您的预定列表中: "Na twojej liście zaplanowanej",
  下载您的产品: "Pobierz swój produkt",
  选项: "Opcja",
  什么都没找到: "Nic nie znalazłem",
  特色产品: "Produkt specjalny",
  最畅销: "Najlepsza -sprzedająca",
  前_名: "Poprzednia nazwa {0}",
  查看更多: "Zobacz więcej",
  查看所有类别: "Zobacz wszystkie kategorie",
  十大品牌: "Dziesięć najlepszych marek",
  查看所有品牌: "Zobacz wszystkie marki",
  登录: "Zaloguj się",
  手机号码: "numer telefonu",
  密码: "hasło",
  密码长度为6到16个字符: "Długość hasła wynosi od 6 do 16 znaków",
  验证码: "Kod weryfikacyjny",
  登录中: "Zaloguj się",
  游客登录: "Logowanie turystyczne",
  注册您的商店: "Zarejestruj swój sklep",
  现在申请: "Złóż wniosek teraz",
  成为商家: "Zostań kupcem",
  现在注册: "Zarejestruj się teraz",
  登录成功: "Udane logowanie",
  通知: "notyfikować",
  未找到通知: "Brak powiadomienia",
  评论: "Komentarz",
  估计运输时间: "Szacowany czas transportu",
  天: "niebo",
  所售: "Sprzedaż",
  给商家留言: "Zostaw wiadomość handlowi",
  规格: "Specyfikacja",
  库存: "w magazynie",
  总价: "Ogólna cena",
  添加到购物车: "Dodaj do koszyka",
  立即购买: "Kup teraz",
  缺货: "Niedobrzeżny",
  添加到愿望清单: "Dodaj listę życzeń",
  加入对比列表: "Dodaj listę porównawczych",
  退款: "Refundacja",
  查看条款: "Zobacz klauzulę",
  分享: "udział",
  描述: "opisać",
  相关产品: "Powiązane produkty",
  没有人问过商家: "Nikt nie zapytał kupca",
  该产品暂无评论: "Nie ma komentarza na temat tego produktu",
  客户评论: "Komentarz klienta",
  访问商店: "Odwiedź sklep",
  畅销产品: "Najlepsze produkty",
  日期: "data",
  订单编号: "Numer zamówienia",
  总额: "ryczałt",
  状态: "państwo",
  愿望清单: "Lista życzeń",
  还没有添加任何东西: "Jeszcze niczego nie dodałem",
  注册: "rejestr",
  邀请码: "Kod zaproszenia",
  请输入邀请码: "Wprowadź kod zaproszenia",
  用户名: "nazwa użytkownika",
  请输入用户名: "Wprowadź nazwę użytkownika",
  用户名长度为6_14个字符: "Długość nazwy użytkownika to 6-14 znaków",
  昵称: "Nic Name",
  请输入手机号码: "Wprowadź numer telefonu komórkowego",
  手机号码格式错误: "Błąd formatu numeru telefonu komórkowego",
  密码长度为6_16个字符: "Długość hasła wynosi 6-16 znaków",
  确认密码: "Potwierdź hasło",
  请输入确认密码: "Wprowadź hasło potwierdzenia",
  提款密码: "Hasło wycofania",
  请输入提款密码: "Wprowadź hasło do wypłaty",
  提款密码长度为4_16个字符: "Długość hasła wypłaty to 4-16 znaków",
  请输入验证码: "Wprowadź kod weryfikacji",
  在_s后发送: "Wyślij po {0} s",
  发送验证码: "Wyślij kod weryfikacji",
  注册即表示您同意我们的条款和条件:
    "Rejestracja oznacza, że ​​zgadzasz się z naszymi warunkami.",
  创建账号: "Utwórz konto",
  验证码发送成功: "Kod weryfikacyjny wysyła pomyślnie",
  确认密码不一致: "Potwierdź, że hasło jest niespójne",
  提款密码必须为数字: "Hasło wypłaty musi być ponumerowane",
  注册成功: "Zarejestruj się pomyślnie",
  购物车: "Koszyk",
  账户: "Konto",
  我的账户: "Moje konto",
  已经有一个账户: "Mają już konto",
  新地址: "Nowy adres",
  编辑地址: "Adres redaktora",
  保存: "ratować",
  是否默认: "Czy domyślnie",
  具体地址: "Konkretny adres",
  请输入具体地址: "Wprowadź konkretny adres",
  地区: "obszar",
  请输入地区: "Wprowadź obszar",
  城市: "Miasto",
  请输入城市: "Wejdź do miasta",
  省份: "województwo",
  请输入省份: "Wprowadź prowincję",
  邮政编码: "kod pocztowy",
  请输入邮政编码: "Wprowadź kod pocztowy",
  电话号码: "numer telefonu",
  请输入电话号码: "Wprowadź numer telefonu",
  收货人: "konsygnatariusz",
  请输入收货人: "Wprowadź odbiornik",
  保存成功: "Powieść się",
  最畅销的商家: "Najlepszy sprzedawca",
  查看所有的商家: "Sprawdź wszystkich kupców",
  支持政策: "Polityka wsparcia",
  您的电子邮件地址: "Twój adres e -mail",
  订阅: "prenumerata",
  联系方式: "Informacje kontaktowe",
  地址: "adres",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Illinois, USA",
  快速链接: "Szybki link",
  商家政策: "Polityka handlowa",
  submit: "składać",
  提款银行卡: "Karta ADBB",
  我的面板: "Mój panel",
  提示: "wskazówka",
  确定登出吗: "Czy na pewno się zalogujesz?",
  确定: "Jasne",
  取消: "Anulować",
  项目添加到您的购物车: "Projekt jest dodawany do twojego koszyka",
  经常一起购买: "Kupuj często",
  返回购物: "Powrót zakupów",
  进行结算: "Przejdź do kasy",
  帮助热线: "Pomoc w infolinii",
  查看所有通知: "Sprawdź wszystkie powiadomienia",
  请输入密码: "Wprowadź hasło",
  前往充值: "Idź do ładowania",
  购物车物品: "Koszyk",
  查看购物车: "Sprawdź koszyk",
  钱包余额: "Równowaga portfela",
  充值钱包: "Torba do ładowania",
  钱包充值_线下_: "Naładowanie portfela (offline)",
  申请提款: "Złóż wniosek o wycofanie",
  钱包收支明细: "Szczegóły dotyczące dochodu i wydatków portfela",
  批准: "zatwierdzić",
  提现历史记录: "Rekrutacja historyczna",
  类型: "typ",
  信息: "informacja",
  付款方式: "Metoda płatności",
  请选择付款方式: "Wybierz metodę płatności",
  Bill_Type_RECHARGE_BACK: "Naładowanie tła",
  Bill_Type_RECHARGE_ONLINE: "Doładowanie online",
  Bill_Type_RECHARGE_REGISTER: "Rejestr",
  Bill_Type_RECHARGE_JACKPOT: "Naładować",
  Bill_Type_RECHARGE_PRESENT: "Nagroda doładowania",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Przeniesienie prowizji",
  Bill_Type_RECHARGE_TG_COMMISSION: "Komisja Promocji Naładowania",
  Bill_Type_REGISTER_TG_COMMISSION: "Komisja ds. Zarejestruj się i promocyjna",
  Bill_Type_WITHDRAW: "Wycofać",
  Bill_Type_WITHDRAW_REJECT: "Wycofać",
  Bill_Type_DEDUCT_HANDLE: "Odliczenie ręczne",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Naładować",
  Bill_Type_MINING_PROFIT: "Dochód wydobywczy",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Komisja promocyjna dochodów wydobywczych",
  Bill_Type_VIP_UPGRADE: "Uaktualnij VIP",
  Bill_Type_FINANCE_BUY: "Zakup produktu zarządzania majątkiem",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Zwrot bilansu finansowego",
  Bill_Type_FINANCE_FEE: "Opłata za obsługę finansową",
  Bill_Type_FINANCE_PROFIT: "Dochód finansowy",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Kupuj prowizje dla produktów do zarządzania majątkiem",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Komisja ds. Zarządzania majątkiem",
  Bill_Type_WHEEL_DRAW: "Duża loteria gramofonowa",
  Bill_Type_BUY: "Kup towary",
  Bill_Type_PAY_SHOP: "Opłata za dostawę",
  Bill_Type_BUY_COMMISSION: "Kup prowizję towarów",
  Bill_Type_DEPOSIT: "Zapłać depozyt",
  Bill_Type_STORE_BUY: "Kup towary",
  Bill_Type_STORE_BUY_REFUND: "Kup zwrot pieniędzy",
  Bill_Type: "Typ zmiany długu",
  Before_Money: "Poprzednia kwota",
  Deal_Money: "Kwota zmiany konta",
  After_Money: "Kolejna kwota",
  Bill_Time: "Czas zmiany konta",
  No_More_Data: "Nigdy więcej danych",
  Apply_Money: "Kwota aplikacji",
  Apply_Time: "Czas aplikacji",
  Withdraw_Info: "Opłata za obsługę: {Fee}, na konto: {Money}",
  提款订单状态_CHECKING: "Do przejrzenia",
  提款订单状态_TRANSFERRING: "Przenosić",
  提款订单状态_PASS: "Potwierdzać",
  提款订单状态_REJECT: "Odrzucony",
  暂无可用充值方式: "Nie ma użytecznej metody ładowania",
  钱包收款码: "Kod kolekcji portfela",
  钱包地址: "Adres portfela",
  金额限制: "Limit kwoty",
  复制: "kopia",
  付款凭证: "Kupon płatności",
  收款银行: "Bank należności",
  收款人: "Kasjer",
  收款账号: "Konto odbioru",
  付款银行: "Bank Pay",
  付款人: "Płatnik",
  付款账号: "Konto płatności",
  请输入付款银行: "Wprowadź bank płatności",
  请输入付款人: "Wprowadź płatnika",
  请输入付款账号: "Wprowadź rachunek płatności",
  请上传付款凭证: "Prześlij kupony płatnicze",
  充值金额: "Naładowanie kwoty",
  请输入充值金额: "Wprowadź kwotę ładowania",
  submitting: "Złożony ...",
  Confirm: "składać",
  Commit_Success: "Udane zgłoszenie",
  balanceType_BALANCE: "Balansować",
  balanceType_COMMISSION: "zamawiać",
  Balance: "Saldo konta",
  Wash_Money: "Kodowanie",
  请选择银行账户: "Wybierz konto bankowe",
  卡号类型: "Numer karty",
  提现金额: "Kwota wypłaty",
  提款金额: "Kwota wypłaty",
  不能为空: "Nie może być pusty",
  金额不正确: "Niepoprawna kwota",
  please_input_withdraw_password: "Wprowadź hasło do wypłaty",
  withdraw_password_format_error: "Hasło wycofania musi mieć 4-16-bitowe znaki",
  Fee: "Opłata za obsługę",
  实际到账: "Faktycznie",
  交易币种: "Waluta handlowa",
  原始密码: "Prymitywne hasło",
  confirm_password_error: "Hasło w dwóch wejściach jest nieprawidłowe",
  save_success: "Powieść się",
  please_input: "Wprowadź",
  old_password: "Stare hasło",
  new_password: "Nowe hasło",
  please_input_confirm_password: "Ponownie potwierdź hasło",
  没有找到符合条件的商品: "Nie mogę znaleźć wykwalifikowanych produktów",
  Search: "szukaj",
  全部: "Wszystko",
  EnumGoodsOrderState_USER_PAY: "Do rozpowszechniania",
  EnumGoodsOrderState_SHOP_PAY: "Dystrybucja",
  EnumGoodsOrderState_SUCCESS: "Skończyć",
  EnumGoodsOrderState_CANCEL: "Anulować",
  EnumGoodsOrderState_REFUND_SUCCESS: "Refundacja",
  订单号: "Numer zamówienia",
  用户名称: "Nazwa użytkownika",
  收益: "dochód",
  支付时间: "Czas zapłać",
  配送时间: "Czas dostawy",
  完成时间: "Ukończ czas",
  发货: "Statek",
  全选: "Pełny wybór",
  物品已添加到愿望清单: "Pozycje zostały dodane do listy życzeń",
  物品已添加到比较列表: "Elementy zostały dodane do listy porównawczej",
  购买成功提示: "Gratulacje, pomyślnie kup",
  订单列表: "Lista zamówień",
  商品名: "Nazwa produktu",
  图片: "zdjęcie",
  没有品牌: "Brak marki",
  基本信息: "Podstawowe informacje",
  Account_Name: "Nazwa",
  Bank_Account: "Rachunek bankowy",
  Bank_Phone: "Zarezerwuj numer telefonu komórkowego",
  IFSC: "Konto IFSC",
  UPI: "Konto UPI",
  PIX: "Numer konta PIX",
  CPF: "Konto CPF",
  GCASH: "Konto GCash",
  POWWI: "Konto Powwi",
  身份证号: "Numer identyfikacyjny",
  Edit: "Poprawiać",
  Delete: "usuwać",
  Add: "Zwiększyć",
  Forget_Withdraw_Password: "Zapomnij o hasłach wypłaty",
  Bank_Card_Info: "Informacje o karcie bankowej",
  收款人地址: "Adres kasjera",
  SWIFT: "Szybki",
  Bank_Branch: "Nazwa sub -marki",
  分行代码: "Kod gałęzi",
  银行地址: "Adres bankowy",
  Email: "E-mail",
  银行卡长度必须超过: "Długość karty bankowej musi przekraczać {długość}",
  银行卡格式不正确: "Format karty bankowej jest nieprawidłowy",
  Do_you_confirm_delete: "Czy potwierdzasz Usuń?",
  Please_Login_First: "Najpierw zaloguj się",
  Bank_Name: "Nazwa banku",
  Please_add_bank_first: "Nie wykupiłeś karty bankowej, najpierw dodaj ją",
  withdrawType: "Wycofanie",
  withdraw_money_limit:
    "Kwota wypłaty musi być większa niż 0 i mniejsza lub równa {Balance}",
  withdraw_times_limit:
    "Wyodrębniłeś dziś {TodayWithDrawnum}. Czy jest zdeterminowany, aby wypłacić pieniądze?",
  Copy_Success: "Replikacja",
  商店首页: "Przechowuj stronę główną",
  所有产品: "Wszystkie produkty",
  新到货产品: "Nowy produkt",
  所有商家: "Wszyscy kupcy",
  请上传: "Proszę przesłać",
  请输入: "Wprowadź",
  忘记密码: "Zapomnij o hasło",
  记得我: "Pamiętaj o mnie",
  共_件: "Total {0} kawałek",
  取消订单: "Anuluj zamówienie",
  申请退款: "Złóż wniosek o zwrot pieniędzy",
  未知商家: "Nieznany kupiec",
  到账: "Konto",
  提款订单状态: "Status zamówienia wycofania",
  前_名类别: "Kategoria pierwszego {0}",
  取消订单原因_不想要了: "Nie chcę już",
  取消订单原因_商品错选_多选: "Błędy produktu/wielokrotny wybór",
  取消订单原因_商品无货: "Out -of -goods",
  取消订单原因_地址信息填写错误: "Wypełnij błąd informacji o adresie",
  取消订单原因_商品降价: "Redukcja cen towarowych",
  取消订单原因_价格高于其他平台: "Cena jest wyższa niż inne platformy",
  取消订单原因_没用_少用_错用优惠: "Nic/Użyj mniej/zniżki błędu",
  退款原因_拍错_多拍_不喜欢: "Weź źle/strzelaj więcej/Nie podoba mi się",
  退款原因_商品成分描述不符: "Opis komponentu produktu nie pasuje",
  退款原因_与商家协商一致退款: "Konsultacje z zwrotem sprzedawcy",
  退款原因_生产日期_保质期与商品描述不符:
    "Data produkcji/okres trwałości nie pasuje do opisu produktu",
  退款原因_图片_产地_批号_规格等描述不符:
    "Obraz/miejsce pochodzenia/numeru/specyfikacji partii itp.",
  退款原因_质量问题: "Problem z jakością",
  退款原因_商品变质_发霉_有异物: "Produkt Paym/Mold/Corget",
  退款原因_少件_含缺少配件_: "Małe przedmioty (w tym brak akcesoriów)",
  退款原因_收到商品时有破损_污渍_变形:
    "Po otrzymaniu produktu występuje uszkodzenie/plama/deformacja",
  退款原因_假冒品牌: "Podrobić",
  退款原因_发票问题: "Problem faktury",
  退款原因_商家发错货: "Kupcy wysyłają niewłaściwe towary",
  退款原因_预约不到_商家不给退换:
    "Nie mogę umówić się na spotkanie/kupca nie zostanie zwrócony",
  退款失败: "Awaria zwrotu",
  退款处理中: "Przetwarzanie zwrotu pieniędzy",
  默认: "domyślny",
  产品查询: "Zapytanie o produkt",
  商店LOGO: "Logo sklepu",
  推广码: "Kod promocyjny",
  查看所有: "Sprawdź wszystkie",
  确认收货成功: "Potwierdź, że paragon zakończy się powodzeniem",
  物流公司: "Firma logistyczna",
  物流单号: "Numer zamówienia logistycznego",
  发货时间: "Czas dostawy",
  请先选择商品规格: "Najpierw wybierz specyfikację produktu",
  个人信息: "Dane osobowe",
  您的用户名: "Twoja nazwa użytkownika",
  你的名字: "Twoje imię",
  登录名: "nazwa użytkownika",
  你的邮件: "Twoja poczta",
  你的密码: "Twoje hasło",
  重复输入密码: "Powtórz hasło",
  店铺名称: "Nazwa sklepu",
  证书类型: "Typ",
  身份证: "Karta identyfikacyjna",
  护照: "paszport",
  驾驶执照: "prawo jazdy",
  社会保障卡: "Karta ubezpieczenia społecznego",
  证书正面: "Pozytywny certyfikat",
  证书反面: "Dowód",
  确认收货: "Potwierdź otrzymanie towarów",
  请选择取消订单的原因必选: "Wybierz powód anulowania zamówienia (wymagane):",
  请选择申请退款的原因必选:
    "Wybierz powód ubiegania się o zwrot pieniędzy (wymagany):",
  留言: "wiadomość",
  请输入留言: "Wprowadź wiadomość",
  没有帐户: "Brak konta",
  钱包充值: "Naładowanie portfela",
  输入您的文字: "Wprowadź swój tekst",
  商家登录: "Logowanie handlowca",
  有关此产品的任何查询: "Wszelkie zapytanie do tego produktu",
  产品名称: "Nazwa produktu",
  你的问题: "Twój problem",
  白银店铺: "Srebrny sklep",
  铂金店铺: "Sklep platynowy",
  钻石店铺: "Sklep z diamentami",
  照片: "zdjęcie",
  已退货: "Zwrócony",
  邮寄状态: "Status poczty",
  订单摘要: "Zamów streszczenie",
  收件地址: "Adres dochodu",
  订购日期: "Data zamówienia",
  订单状态: "Status zamówienia",
  总订单金额: "Całkowita kwota zamówienia",
  邮寄方式: "Metoda mailingowa",
  附加信息: "Dodatkowe informacje",
  订单详细信息: "Szczegółowe informacje",
  交货类型: "Typ dostawy",
  进行评论: "Komentarz",
  已评论: "Skomentował",
  订单金额: "Kwota zamówienia",
  优惠券: "Kupon",
  统一运费: "Ujednolicony fracht",
  送货地址: "Adres wysyłki",
  评分: "wynik",
  你的意见: "Twoja opinia",
  匿名: "anonimowy",
  现金: "gotówka",
  详情: "Szczegół",
  收货地址: "Adres paragonu",
  暂时没有对话: "Na razie brak dialogu",
  你: "Ty",
  输入您的回复: "Wprowadź swoją odpowiedź",
  删除成功: "Usuwać",
  品牌: "marka",
  已缴纳的保证金: "Zapłacona margines",
  黄金店铺: "Złoty sklep",
  没有更多数据: "Nigdy więcej danych",
  站内信: "Na literie",
  系统通知: "Powiadomienie systemu",
  邮箱: "Poczta",
  手机号: "Numer telefonu",
  你的手机号: "Twój numer telefonu komórkowego",
  营业执照: "Licencja biznesowa",
  你的邮箱: "Twoja skrzynka pocztowa",
  搜索结果: "Wyniki wyszukiwania",
  系统公告: "Ogłoszenie systemu",
  客服: "obsługa klienta",
  消息已撤回: "Wiadomość została wycofana",
  物流详情: "Szczegóły logistyczne",
  充值: "uzupełniać",
  提现: "Wycofać",
  信用分: "Kredyt",
  余额: "Balansować",
  佣金: "zamawiać",
  继续购物: "Kontynuuj zakupy",
  订单结算: "Ugoda zamówienia",
  加入对比: "Dodaj porównanie",
  佣金余额: "Równowaga prowizji",
  刷新: "odświeżać",
  刷新成功: "Odświeżać",
  官网: "Oficjalna strona internetowa",
  税号: "Numer podatkowy",
  订单: "Zamówienie",
  合计: "całkowity",
  系统安全: "Bezpieczeństwo systemu",
  Recharge_Money_Limit: "Kwota doładowania musi wynosić między {min} i {max}",
  限时优惠: "Ograniczony czas",
  高价回收: "Wysokie recykling",
  姓名: "Nazwa",
  商品订单号: "Numer zamówienia towarowego",
  商品在线回收: "Recykling online towarów",
  提交: "składać",
  回收记录: "Rekord odzyskiwania",
  回收状态: "Status odzyskiwania",
  回收价格: "Cena recyklingu",
  纳税码: "Kod podatkowy",
  买家登录: "Zaloguj się",
  买家注册: "rejestr",
  助力提示:
    "Pomoc handlowcom może zwiększyć ekspozycję platformy na ich sklepy, a im wyższa liczba dni, tym wyższa ekspozycja.",
  已累计助力: "Wspomagany łącznie",
  今日已助力: "Dzisiaj pomógł",
  立即助力: "Pomóż natychmiast",
  商家助力: "Pomoc handlowca",
  证件号码: "Numer identyfikacyjny",
  证书号码: "Numer certyfikatu",
  男鞋: "Buty męskie",
  游戏玩具: "Zabawki gier",
  使用条款: "Warunki użytkowania",
  商家: "Kupiec",
  已助力: "Pomógł",
  被助力: "Pomoc",
  用户: "użytkownik",
  助力记录: "POMOC REJESTRACJA",
  消息类型: "Typ wiadomości",
  消息内容: "Treść wiadomości",
  链接: "Połączyć",
  文本: "tekst",
  清空: "Jasne",
  评论成功: "Komentarz udany",
  扫描二维码: "Zeskanuj kod QR",
  转入: "przenieść się",
  收款: "Kolekcja",
  任务下单中心: "Centrum zamówień zadań",
  记录: "rekord",
  任务倒计时: "Odliczanie zadań",
  倒计时后自动放弃: "Automatycznie poddaj się po odliczeniu",
  业务码: "Kod biznesowy",
  选择商品分类: "Wybierz kategorię produktu",
  可多选: "Możliwość wielokrotnego wyboru",
  加载分类中: "Ładowanie kategorii",
  暂无分类: "Nie ma jeszcze klasyfikacji",
  产品类别: "Kategoria produktu",
  账户余额: "Saldo konta",
  立即结算: "Rozliczenie natychmiast",
  任务已自动放弃: "Zadanie zostało automatycznie porzucone",
  商品分类: "Klasyfikacja produktu",
  订单详情: "Szczegóły zamówienia",
  预计收益: "Szacowane przychody",
  预计佣金收益: "Szacowany dochód z prowizji",
  收益率: "Wydajność",
  扣款账户: "Konto debetowe",
  确认结算: "Potwierdź rozliczenie",
  未选择: "Nie wybrano",
  请选择商品分类: "Proszę wybrać kategorię produktu",
  下单成功: "Zamówienie złożone pomyślnie",
  下单失败: "Zamówienie nie powiodło się",
  请重试: "Spróbuj ponownie",
  订单记录: "Zapis zamówienia",
  没有更多了: "nigdy więcej",
  业务号: "Numer biznesowy",
  商品类型: "Typ produktu",
  佣金收益: "dochód z prowizji",
  待结算: "Oczekujące na rozliczenie",
  已结算: "Ustalone",
  已取消: "Anulowano",
  加载失败: "Ładowanie nie powiodło się",
  倒计时: "Odliczanie",
  随机商品: "losowe przedmioty",
  为: "dla",
  商户助力可提升商品曝光度:
    "Pomoc sprzedawcy może zwiększyć ekspozycję produktu",
  累计助力越高推荐权重越高:
    "Im wyższa skumulowana pomoc, tym wyższa waga zalecenia.",
  实时助力动态: "Dynamika pomocy w czasie rzeczywistym",
  助力奖励: "Zwiększaj nagrody",
  随机奖励金额已生成: "Wygenerowano losową kwotę nagrody",
  开心收下: "Chętnie to zaakceptuję",
  助力已结束: "Pomoc dobiegła końca",
  助力成功: "Pomóż odnieść sukces",
  成功: "sukces",
  进行中: "W toku",
  等待: "poczekaj",
  助力失败: "Pomoc nie powiodła się",
  任務: "Zadanie",
  下单失败_请稍后重试: "Zamówienie nie powiodło się, spróbuj ponownie później",
  任务: "Zadanie"
};
